export class ProjectVisitMapConfig {
  constructor(
    public readonly id: string,
    public readonly withinNDays: number,
    public readonly color: string,
    public readonly createdAt: Date,
    public readonly updatedAt: Date,
  ) {
  }

  static fromJson(json: any): ProjectVisitMapConfig {
    return new ProjectVisitMapConfig(
      json['id'],
      json['within_x_days'],
      json['color'],
      new Date(json['created_at']),
      new Date(json['updated_at']),
    )
  }
}